<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['lt']),
    purchaseTicket() {
      return this.$route.query.purchaseTicket;
    },
    appIdentifier() {
      return this.$route.query.appIdentifier;
    },
    redirectUrl() {
      const url = new URL(`https://${this.appIdentifier}.app.${this.BRAND_CONFIG.domain}`);
      url.pathname = '/process-purchase';
      url.searchParams.set('purchaseTicket', this.purchaseTicket);
      url.searchParams.set('appIdentifier', this.appIdentifier);
      url.searchParams.set('lt', this.lt);
      return url.toString();
    },
  },
  methods: {
    redirect() {
      if (!this.lt) {
        this.$router.replace({
          path: '/init-purchase/auth',
          query: {
            purchaseTicket: this.purchaseTicket,
            appIdentifier: this.appIdentifier,
          },
        });
        return;
      }

      window.location.replace(this.redirectUrl);
    },
  },
  created() {
    this.redirect();
  },
};
</script>
